export const initialState = {
  gameCardBox: [],
  pointsPlayer: 0,
  pointsSistem: 0,
  currentCardValue: 0,
  sistenCurrentCardValue: 0,
  playSistem: false,
  finish: false,
  disabled: false,
  shuffle: false,
  error: "",
};

